export default __webpack_public_path__ + "static/media/searchBlue.b1ab2009.svg";